export default "__VITE_ASSET__QwVUZYp3__"